<template>
  <div class="ra-breadcrumb">
    <el-breadcrumb separator-class="ra-icon--chevron-right">
      <el-breadcrumb-item
        v-for="(route, index) in routes"
        :key="index"
        :to="{ path: route.path }"
        >{{ route.label }}</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="is-flex is-align-center">
      <headway-widget />
      <organisation-switch />
    </div>
  </div>
</template>

<script>
import OrganisationSwitch from "@/components/Organisation/OrganisationSwitch";
import HeadwayWidget from "@/components/Home/Headway.vue";

export default {
  name: "RaBreadcrumb",
  components: { HeadwayWidget, OrganisationSwitch },
  props: {
    routes: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {};
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.ra-breadcrumb {
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
